import { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { HttpPostData } from "../../../common/Util";
import { TitleParamContext } from "../../../context/TitleContext";
import { ResponseParamBase } from "../../../common/Types";
import { Grid, Box } from "@mui/material";
import { CenterBox, OnsiteProgress } from '../../../customelements/CustomInput';
import queryString from 'query-string';


export type ResponseParam = ResponseParamBase  & {
    
}

type PageParam = {
    mailtoken: string,
}

export const ChangeMailAddressComp = () => {

    const ctx = useContext(TitleParamContext);
    const location = useLocation();
    const navigate = useNavigate();
    const pageParam = queryString.parse(location.search) as PageParam;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    useEffect(() => {
        (async () => {
            ctx.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "メールアドレス変更", secondSubTitle: "（本登録）" });
            HttpPostData<ResponseParam>("/UserManager/ChangeEmail", { mailToken: pageParam.mailtoken }, setIsLoading)
                .then((response) => {
                    if (response.data.resultFlg) {
                        setMessage(response.data.message);
                    } else {
                        setMessage(response.data.message);
                    }
                })
                .catch(e => { console.log(e) });
        })()
    }, []);

    return (
        <>
            <CenterBox>
                <Grid container spacing={3} alignItems="stretch" justifyContent="center" direction="column">
                    <Grid item xs={1}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "lightgray", paddingTop: 20, paddingBottom: 20, fontSize: 20 }}>
                            {
                                isLoading ?
                                    <OnsiteProgress></OnsiteProgress>
                                    :
                                    <div>{message}</div> 
                            }                            
                        </Box>
                    </Grid>
                </Grid>
            </CenterBox>
        </>
    );
}  